<template>
  <PopperIcon
    :button-classes="buttonClasses"
    :placement="placement"
    icon="zmdi-help-outline"
    :default-slot-is-inline="defaultSlotIsInline"
  >
    <slot name="full-control">
      <div class="help">
        <slot />
      </div>
    </slot>
  </PopperIcon>
</template>

<script>
// TODO: If possible making this file functional would be greatly appreciated
import PopperIcon from '@/components/PopperIcon.vue'

export default {
  name: 'PopperIconHelp',
  components: {
    PopperIcon,
  },
  props: {
    buttonClasses: {
      type: [Object, Array, String],
      default: () => [],
    },
    defaultSlotIsInline: {
      type: Boolean,
      default: false,
    },
    placement: {
      type: String,
      default: 'top',
    },
  },
}
</script>

<style scoped lang="scss">
.help {
  padding: 10px;
  min-width: 200px;
}
</style>
